import React from "react"
import { LangItem } from "../core/Helpers/LangItem";
import { Fa } from "./Fa"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";


type contactItemProps = {
    title: string;
    icon?: string | IconProp;
    href: string;
    value: string;
    newFA?: boolean;
}

class ContactItemView extends React.Component {
    props: contactItemProps
    constructor(props: contactItemProps){
        super(props)
        this.props = props
    }

    render(){
        const { title, icon, href, value, newFA} = this.props
        return <div className='contact-info-section'>
                <div className='contact-info-section-title'>
                    <LangItem for={title}/>
                </div>
                <div className='contact-info-value'>
                    <div className='contact-info-value-img'>
                        <div className="icon-wrapper">
                            {newFA ? (
                                  <FontAwesomeIcon icon={icon as IconProp} />
                            ) : (
                                icon && <Fa icon={icon} />
                            )}
                        </div>
                    </div>
                    <a href={href} target="_blank" rel="noreferrer" className='contact-info-value-content'>
                        {value}
                    </a>
                </div>
            </div>
    }
}

export { ContactItemView }
